import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const BannerContainer = styled.div`
  background: #0f212e;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  height: 220px;
  display: flex;
  flex-shrink: 0;
  border: 1px solid rgba(255, 255, 255, 0.05);
  transition: all 0.3s ease;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;

  &:hover {
    border-color: rgba(255, 255, 255, 0.1);
  }

  @media (max-width: 768px) {
    height: 180px;
  }
`;

const RightSideGradient = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 50%;
  border-radius: 0 8px 8px 0;
`;

const BannerImage = styled.img`
  position: absolute !important;
  right: 0 !important;
  top: 0 !important;
  bottom: 0 !important;
  height: 100% !important;
  width: 50% !important;
  object-fit: cover !important;
  border-radius: 0 8px 8px 0 !important;
  opacity: 0.8 !important;
  transition: opacity 0.3s ease !important;

  ${BannerContainer}:hover & {
    opacity: 1 !important;
  }
`;

const LeftSideContent = styled.div`
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: 50%;
  height: 100%;
  padding: 16px 24px;

  @media (max-width: 768px) {
    padding: 12px 16px;
  }
`;

const TagBadge = styled.span`
  display: inline-block;
  align-self: flex-start;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background: rgba(47, 128, 237, 0.15);
  color: #559cfc;
`;

const Title = styled.h3`
  margin-top: 6px;
  font-size: 20px;
  font-weight: 800;
  color: #ffffff;
  line-height: 1.2;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  transition: color 0.3s;

  ${BannerContainer}:hover & {
    color: #559cfc;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    margin-top: 6px;
  }
`;

const Subtitle = styled.p`
  font-size: 14px;
  color: #98a6b3;
  margin-top: 2px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const CtaButton = styled.button`
  margin-top: auto;
  align-self: flex-start;
  padding: 0 20px !important;
  height: 40px !important;
  border-radius: 6px !important;
  border: 1px solid rgba(255, 255, 255, 0.35) !important;
  background: transparent !important;
  color: #ffffff !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  cursor: pointer !important;
  transition: all 0.2s ease-in-out !important;

  &:hover {
    background: rgba(255, 255, 255, 0.12) !important;
    border-color: rgba(255, 255, 255, 0.55) !important;
  }

  @media (max-width: 768px) {
    height: 32px !important;
    padding: 0 12px !important;
    font-size: 12px !important;
  }
`;

export function PromoBanner({ tag, title, sub, cta, grad, image, to }) {
  const content = (
    <BannerContainer>
      <RightSideGradient style={{ background: grad }} />
      {image && <BannerImage src={image} alt="" />}
      <LeftSideContent>
        <TagBadge>{tag}</TagBadge>
        <Title>{title}</Title>
        <Subtitle>{sub}</Subtitle>
        <CtaButton>{cta}</CtaButton>
      </LeftSideContent>
    </BannerContainer>
  );

  if (to) {
    return <Link to={to} style={{ textDecoration: "none", width: "100%" }}>{content}</Link>;
  }

  return content;
}

export default PromoBanner;
